import { Component, EventEmitter, Output } from '@angular/core';
import { parseSerialsCsv, parseSerialsXls } from './serial-matching';

const MAX_FILE_BYTES = 5 * 1024 * 1024;

/**
 * Button next to the device search: upload the device list exported from
 * MagicInfo (.xls) or a CSV of serial numbers.
 */
@Component({
  selector: 'app-serial-csv-upload',
  templateUrl: './serial-csv-upload.component.html',
  styleUrls: ['./serial-csv-upload.component.scss'],
  standalone: false
})
export class SerialCsvUploadComponent {
  /** Serials read from the file. */
  @Output() serialsLoaded = new EventEmitter<string[]>();
  /** Why a file could not be used. */
  @Output() failed = new EventEmitter<string>();

  async onFileSelected(input: HTMLInputElement): Promise<void> {
    const file = input.files?.[0];
    input.value = '';
    if (!file) return;

    if (/\.xlsx$/i.test(file.name)) {
      this.failed.emit('Excel .xlsx files are not supported. Upload the .xls device list exported from MagicInfo, or save the file as CSV.');
      return;
    }
    if (!/\.(xls|csv|txt)$/i.test(file.name)) {
      this.failed.emit('Upload the device list exported from MagicInfo (.xls), or a .csv file with a "serial" column.');
      return;
    }
    if (file.size > MAX_FILE_BYTES) {
      this.failed.emit('The file is too large (5 MB maximum).');
      return;
    }

    const { serials, error } = /\.xls$/i.test(file.name)
      ? parseSerialsXls(await file.arrayBuffer())
      : parseSerialsCsv(await file.text());
    if (error || !serials.length) {
      this.failed.emit(error ?? 'The file has no serial numbers.');
      return;
    }
    this.serialsLoaded.emit(serials);
  }
}
